export default "__VITE_ASSET__BzK3BQdm__"